function getFocusable(container) {
    if (!container) return []

    var nodes = container.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')

    return Array.prototype.filter.call(nodes, function (el) {
        if (el.getAttribute('aria-hidden') === 'true') return false
        if (el.closest('[hidden]')) return false
        if (el.closest('[inert]')) return false
        if (el.offsetParent === null && el.getClientRects().length === 0) return false
        return true
    })
}

function syncDrawerOffset() {
    var top = document.querySelector('.header__top')
    if (!top) return

    var bottom = Math.round(top.getBoundingClientRect().bottom)
    document.documentElement.style.setProperty('--header-top-height', Math.max(0, bottom) + 'px')
}

function keepHeaderVisible() {
    var header = document.getElementById('header')
    if (header) header.classList.remove('is-hidden')
}

function setDrawerOpen(isOpen) {
    var hamburger = document.querySelector('.hamburger')
    var drawer = document.getElementById('header-drawer')
    var label = hamburger && hamburger.querySelector('.hamburger__label')
    var content = document.getElementById('content')

    if (isOpen) {
        keepHeaderVisible()
        syncDrawerOffset()
    }

    document.body.classList.toggle('is-drawer', isOpen)

    if (hamburger) {
        hamburger.classList.toggle('is-active', isOpen)
        hamburger.setAttribute('aria-expanded', isOpen ? 'true' : 'false')
        if (label) {
            label.textContent = isOpen
                ? (hamburger.getAttribute('data-label-close') || 'Close menu')
                : (hamburger.getAttribute('data-label-open') || 'Open menu')
        }
    }

    if (drawer) {
        if (isOpen) {
            drawer.removeAttribute('inert')
        } else {
            drawer.setAttribute('inert', '')
        }
    }

    if (content) {
        if (isOpen) {
            content.setAttribute('inert', '')
        } else {
            content.removeAttribute('inert')
        }
    }
}

jQuery('.body__before').on('click', function(e) {

    if( jQuery('body').hasClass('is-drawer') ){
        setDrawerOpen(false)
        jQuery('.hamburger').trigger('focus')
    }
    if(jQuery('body').hasClass('is-search')){
        jQuery('body').toggleClass('is-search')
    }

})

jQuery(document).on('keydown', function (e) {

    if (e.key !== 'Escape' && e.keyCode !== 27) return

    if (e.keyCode === 27 && jQuery('.header__search.is-open').length) {
        jQuery('.header__search').removeClass('is-open');
        jQuery('.header__search-toggle').attr('aria-expanded', 'false');
        setTimeout(function () {
            jQuery('.header__search-toggle').focus();
        }, 100);
        return;
    }

    if( jQuery('body').hasClass('is-search') ){
        jQuery('body').removeClass('is-search');
        setTimeout(function () {
            jQuery('.header__search-toggle').focus();
        }, 100);
        return;
    }

    if( jQuery('body').hasClass('is-drawer') ){
        setDrawerOpen(false)
        setTimeout(function () {
            jQuery('.hamburger').focus()
        }, 100)
    }
});

jQuery('.header__search-toggle').on('click', function (e) {
    e.preventDefault()
    e.stopPropagation()

    var $search = jQuery(this).closest('.header__search')

    $search.addClass('is-open')
    jQuery(this).attr('aria-expanded', 'true')
    keepHeaderVisible()
    jQuery('.header__nav__item.open').removeClass('open').find('.header__nav__toggle').attr('aria-expanded', 'false')
    jQuery('.header__nav .mega-panel').attr('hidden', true)
    setDrawerOpen(false)

    setTimeout(function () {
        $search.find('input[type="search"]').trigger('focus')
    }, 50)
})

jQuery(document).on('click', function (e) {
    var $search = jQuery('.header__search.is-open')

    if ($search.length && !jQuery(e.target).closest('.header__search').length) {
        $search.removeClass('is-open')
        $search.find('.header__search-toggle').attr('aria-expanded', 'false')
    }
})

jQuery('.hamburger').on('click', function (e) {

    e.preventDefault()

    var willOpen = !document.body.classList.contains('is-drawer')

    jQuery('.header__search').removeClass('is-open')
    jQuery('.header__search-toggle').attr('aria-expanded', 'false')
    jQuery('.header__nav__item.open').removeClass('open').find('.header__nav__toggle').attr('aria-expanded', 'false')
    jQuery('.header__nav .mega-panel').attr('hidden', true)

    setDrawerOpen(willOpen)

    var drawer = document.getElementById('header-drawer')
    if (drawer) drawer.scrollTop = 0

    if (willOpen) {
        setTimeout(function () {
            var search = drawer && drawer.querySelector('#drawer-search')
            if (search) {
                search.focus({ preventScroll: true })
            } else {
                var first = getFocusable(drawer)[0]
                if (first) first.focus({ preventScroll: true })
            }
        }, 50)
    }

})

window.matchMedia('(min-width: 1280px)').addEventListener('change', function (e) {
    if (e.matches && jQuery('body').hasClass('is-drawer')) {
        setDrawerOpen(false)
    }

    if (!e.matches) {
        jQuery('.header__nav__item.open').removeClass('open').find('.header__nav__toggle').attr('aria-expanded', 'false')
        jQuery('.header__nav .mega-panel').attr('hidden', true)
    }
})

window.addEventListener('resize', function () {
    if (document.body.classList.contains('is-drawer')) {
        syncDrawerOffset()
    }
})

document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || !document.body.classList.contains('is-drawer')) return

    var headerEl = document.getElementById('header')
    var focusables = getFocusable(headerEl)

    if (!focusables.length) return

    var first = focusables[0]
    var last = focusables[focusables.length - 1]
    var current = document.activeElement

    if (e.shiftKey && current === first) {
        e.preventDefault()
        last.focus()
    } else if (!e.shiftKey && current === last) {
        e.preventDefault()
        first.focus()
    }
});


// Accessible desktop mega menu: disclosure buttons, one panel open at a time.
(function () {

    var mainNav = document.querySelector('.header__nav__nav');

    if (!mainNav) return;

    var entries = Array.prototype.slice
        .call(mainNav.querySelectorAll('.header__nav__item'))
        .map(function (item) {
            var trigger = item.querySelector('.header__nav__toggle');
            var panel = item.querySelector(':scope > .mega-panel');

            if (!trigger || !panel) return null;

            return {
                item: item,
                trigger: trigger,
                panel: panel
            };
        })
        .filter(Boolean);

    if (!entries.length) return;

    function closeEntry(entry, returnFocus) {
        entry.item.classList.remove('open');
        entry.trigger.setAttribute('aria-expanded', 'false');
        entry.panel.setAttribute('hidden', '');
        if (returnFocus) entry.trigger.focus();
    }

    function closeAll(except) {
        entries.forEach(function (entry) {
            if (entry !== except) closeEntry(entry, false);
        });
    }

    function openEntry(entry) {
        closeAll(entry);
        entry.item.classList.add('open');
        entry.trigger.setAttribute('aria-expanded', 'true');
        entry.panel.removeAttribute('hidden');
        keepHeaderVisible();
    }

    var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    function toggleEntry(entry) {
        if (entry.item.classList.contains('open')) {
            closeEntry(entry, false);
        } else {
            openEntry(entry);
        }
    }

    function getPanelFocusables(panel) {
        return getFocusable(panel);
    }

    function focusTrigger(index) {
        var i = (index + entries.length) % entries.length;
        entries[i].trigger.focus();
    }

    entries.forEach(function (entry) {

        entry.trigger.addEventListener('click', function (e) {
            e.preventDefault();
            toggleEntry(entry);
        });

        entry.trigger.addEventListener('keydown', function (e) {
            var index = entries.indexOf(entry);
            var panelItems;

            if (e.key === 'Escape') {
                e.preventDefault();
                closeEntry(entry, true);
            } else if (e.key === 'ArrowDown' || e.key === 'Down') {
                e.preventDefault();
                openEntry(entry);
                panelItems = getPanelFocusables(entry.panel);
                if (panelItems[0]) panelItems[0].focus();
            } else if (e.key === 'ArrowUp' || e.key === 'Up') {
                e.preventDefault();
                openEntry(entry);
                panelItems = getPanelFocusables(entry.panel);
                if (panelItems.length) panelItems[panelItems.length - 1].focus();
            } else if (e.key === 'ArrowRight' || e.key === 'Right') {
                e.preventDefault();
                closeEntry(entry, false);
                focusTrigger(index + 1);
            } else if (e.key === 'ArrowLeft' || e.key === 'Left') {
                e.preventDefault();
                closeEntry(entry, false);
                focusTrigger(index - 1);
            } else if (e.key === 'Home') {
                e.preventDefault();
                closeEntry(entry, false);
                focusTrigger(0);
            } else if (e.key === 'End') {
                e.preventDefault();
                closeEntry(entry, false);
                focusTrigger(entries.length - 1);
            }
        });

        entry.panel.addEventListener('keydown', function (e) {
            var panelItems;
            var currentIndex;

            if (e.key === 'Escape') {
                e.preventDefault();
                closeEntry(entry, true);
                return;
            }

            if (e.key !== 'ArrowDown' && e.key !== 'Down' && e.key !== 'ArrowUp' && e.key !== 'Up') {
                return;
            }

            panelItems = getPanelFocusables(entry.panel);
            currentIndex = panelItems.indexOf(document.activeElement);

            if (currentIndex === -1) return;

            e.preventDefault();

            if (e.key === 'ArrowDown' || e.key === 'Down') {
                if (currentIndex === panelItems.length - 1) {
                    entry.trigger.focus();
                } else {
                    panelItems[currentIndex + 1].focus();
                }
            } else if (currentIndex === 0) {
                entry.trigger.focus();
            } else {
                panelItems[currentIndex - 1].focus();
            }
        });

        if (canHover) {
            entry.item.addEventListener('mouseenter', function () {
                openEntry(entry);
            });
        }

        entry.trigger.addEventListener('focus', function () {
            closeAll(entry);
        });
    });

    if (canHover) {
        var navHolder = mainNav.closest('.header__nav__holder') || mainNav;
        var closeTimer = null;

        var cancelPendingClose = function () {
            if (!closeTimer) return;
            clearTimeout(closeTimer);
            closeTimer = null;
        };

        navHolder.addEventListener('mouseenter', cancelPendingClose);

        navHolder.addEventListener('mouseleave', function () {
            cancelPendingClose();

            closeTimer = setTimeout(function () {
                closeTimer = null;
                if (navHolder.contains(document.activeElement)) return;
                closeAll(null);
            }, 250);
        });

        var navActions = navHolder.querySelector('.header__nav__actions');

        if (navActions) {
            navActions.addEventListener('mouseenter', function () {
                cancelPendingClose();
                closeAll(null);
            });
        }
    }

    document.addEventListener('click', function (e) {
        if (!mainNav.contains(e.target)) closeAll(null);
    });
    document.addEventListener('focusin', function (e) {
        if (!mainNav.contains(e.target)) closeAll(null);
    });

})();


function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches
}

function closeDrawerPanel(item, animate) {
    var wrapper = item.children('.drawer__nav-dropdown')
    var panel = item.children('.drawer__panel')

    wrapper.removeClass('open')
    item.removeClass('open')
    wrapper.find('.drawer__nav-toggle').attr('aria-expanded', 'false')
    panel.stop(true, true)

    if (animate && !prefersReducedMotion()) {
        panel.slideUp(function () {
            panel.attr('hidden', true)
        })
    } else {
        panel.hide().attr('hidden', true)
    }
}

function scrollDrawerItemToTop(itemEl) {
    var drawer = document.getElementById('header-drawer')
    if (!drawer || !itemEl) return

    var sync = function () {
        var nextTop = drawer.scrollTop + itemEl.getBoundingClientRect().top - drawer.getBoundingClientRect().top
        drawer.scrollTop = Math.max(0, nextTop)
    }

    sync()
    window.requestAnimationFrame(sync)
}

jQuery('.drawer__nav .drawer__nav-toggle').on('click', function (e) {

    e.preventDefault()

    var toggle = jQuery(this)
    var item = toggle.closest('.drawer__item')
    var wrapper = toggle.closest('.drawer__nav-dropdown')
    var panel = item.children('.drawer__panel')
    var isOpen = wrapper.hasClass('open')

    if (isOpen) {
        closeDrawerPanel(item, true)
        return
    }

    // Close any other section immediately so the new list is not opened
    // against leftover height/scroll from the previous accordion.
    item.siblings().each(function () {
        var otherItem = jQuery(this)
        if (otherItem.children('.drawer__nav-dropdown').hasClass('open')) {
            closeDrawerPanel(otherItem, false)
        }
    })

    wrapper.addClass('open')
    item.addClass('open')
    toggle.attr('aria-expanded', 'true')

    panel.stop(true, true).removeAttr('hidden')

    if (prefersReducedMotion()) {
        panel.show()
    } else {
        panel.hide().slideDown()
    }

    scrollDrawerItemToTop(item.get(0))

})

;(function () {
    var toggles = Array.prototype.slice.call(document.querySelectorAll('.drawer__nav .drawer__nav-toggle'))

    if (!toggles.length) return

    toggles.forEach(function (toggle, index) {
        toggle.addEventListener('keydown', function (e) {
            var next

            if (e.key === 'ArrowDown' || e.key === 'Down') {
                e.preventDefault()
                next = toggles[index + 1] || toggles[0]
                next.focus()
            } else if (e.key === 'ArrowUp' || e.key === 'Up') {
                e.preventDefault()
                next = toggles[index - 1] || toggles[toggles.length - 1]
                next.focus()
            } else if (e.key === 'Home') {
                e.preventDefault()
                toggles[0].focus()
            } else if (e.key === 'End') {
                e.preventDefault()
                toggles[toggles.length - 1].focus()
            }
        })
    })
})()

;(function () {
    var header = document.getElementById('header')

    if (!header) return

    var headerTop = header.querySelector('.header__top')
    var headerRight = header.querySelector('.header__right')
    var desktopQuery = window.matchMedia('(min-width: 1280px)')
    var DELTA = 10
    var HIDE_EXTRA = 100
    var COMPACT_FALLBACK = 64
    var lastY = window.scrollY
    var fullHeight = 0
    var compactHeight = 0
    var ticking = false

    function currentHeight() {
        return (headerTop || header).offsetHeight
    }

    function measure() {
        if (header.classList.contains('is-hidden')) return

        if (header.classList.contains('is-compact')) {
            compactHeight = currentHeight()
            return
        }

        fullHeight = currentHeight()
        document.documentElement.style.setProperty('--header-height', fullHeight + 'px')
    }

    // Compacting while the page is still near the top would leave a gap
    // between the shorter header and the content it no longer covers, so wait
    // until the full header has scrolled out of view.
    function getCompactOffset() {
        return Math.max(0, fullHeight - (compactHeight || COMPACT_FALLBACK))
    }

    function getHideOffset() {
        return fullHeight + HIDE_EXTRA
    }

    function setRightInert(isCompact) {
        if (!headerRight) return

        if (isCompact) {
            headerRight.setAttribute('inert', '')
            headerRight.setAttribute('aria-hidden', 'true')
        } else {
            headerRight.removeAttribute('inert')
            headerRight.removeAttribute('aria-hidden')
        }
    }

    function hasOpenPanel() {
        if (header.querySelector('.header__nav__item.open')) return true
        if (header.querySelector('.header__search.is-open')) return true
        return false
    }

    function shouldStayVisible() {
        if (document.body.classList.contains('is-drawer')) return true
        if (hasOpenPanel()) return true
        if (header.contains(document.activeElement)) return true
        return false
    }

    function update() {
        ticking = false

        var y = window.scrollY
        var delta = y - lastY
        var wasCompact = header.classList.contains('is-compact')
        var compact = false

        if (desktopQuery.matches) {
            // Resizing the header would move an open panel out from under the
            // pointer, so hold the current state until it is closed.
            if (hasOpenPanel()) {
                compact = wasCompact
            } else {
                var offset = getCompactOffset()
                compact = wasCompact ? y > offset - DELTA : y >= offset
            }
        }

        header.classList.toggle('is-compact', compact)
        setRightInert(compact)

        if (compact && !compactHeight) {
            setTimeout(measure, 320)
        }

        if (shouldStayVisible() || y <= getHideOffset()) {
            header.classList.remove('is-hidden')
            lastY = y
            return
        }

        if (Math.abs(delta) < DELTA) return

        if (delta > 0) {
            header.classList.add('is-hidden')
        } else {
            header.classList.remove('is-hidden')
        }

        lastY = y
    }

    function onScroll() {
        if (ticking) return
        ticking = true
        window.requestAnimationFrame(update)
    }

    window.addEventListener('scroll', onScroll, { passive: true })
    window.addEventListener('load', measure)
    window.addEventListener('resize', function () {
        measure()
        update()
    })
    desktopQuery.addEventListener('change', function () {
        lastY = window.scrollY
        measure()
        update()
    })
    header.addEventListener('focusin', keepHeaderVisible)
    measure()
    update()
})()

